import { useTranslation } from 'react-i18next';
import Modal from '../../../components/Modal/Modal';

interface Props {
  isModalOpened: boolean;
  closeModal: () => void;
}

export default function AdjustmentsModal({ isModalOpened, closeModal }: Props) {
  const { t } = useTranslation();
  return (
    <Modal isOpened={isModalOpened} close={closeModal} title={t('Information')}>
      <div className='mx-3 pt-3 pb-4 px-3'>
        <div className='fw-800 Text'>{t('Invoice adjustments')}</div>
        <div className='mb-3'>
          {t(
            'Since the date of crossing the €10,000 threshold the invoices should contain VAT rate of arrival country for all B2C-sales (not departure country, like it was before crossing the threshold)'
          )}
        </div>
        <div>
          {t('More on')}&nbsp;
          <a
            href='https://vat-one-stop-shop.ec.europa.eu/one-stop-shop/declare-and-pay-oss_en'
            target='_blank'
            rel='noopener noreferrer'
            className='Link--blue'
          >
            {t('European Commission')}
          </a>
        </div>
      </div>
    </Modal>
  );
}
